import React from "react";
import useForegetPassAcitons from "../../assets/Hooks/getForgetPassActions";
import Loading from "../../assets/containers/loadingDialog";

const ForgetpassRenewPage = () => {
  const {
    newPass,
    newPassRep,
    loading,
    handleChangeNewPassInput,
    handleChangeNewPassRep,
    changePassWithOtp,
  } = useForegetPassAcitons();
  return (
    <>
      <h5 className="text-center">بازنشانی رمز عبور</h5>
      <form>
        <p>رمز عبور جدید</p>
        <input
          placeholder="رمز عبور"
          value={newPass}
          onChange={handleChangeNewPassInput}
          name="nationalCode"
          autoComplete="off"
        />
        <p>تکرار رمز عبور</p>
        <input
          placeholder="تکرار رمز عبور"
          value={newPassRep}
          onChange={handleChangeNewPassRep}
          name="nationalCode"
          autoComplete="off"
        />
        {loading ? (
          <Loading
            className={"d-flex justify-content-center mt-4 mb-2"}
            size={30}
          />
        ) : (
          <button onClick={changePassWithOtp}>ثبت</button>
        )}
      </form>
    </>
  );
};

export default ForgetpassRenewPage;
